import { AppThunk } from '../../../store/rootReducer';
import * as delineationActions from '../actions/delineation.actions';
import { DelineationId } from '../types/delineation.type';

interface SelectOptions {
  history?: boolean; // we want to allow undo when the user triggers it but not during the first load
}

export const selectDelineation =
  (
    delineationId: DelineationId,
    { history = true }: SelectOptions = {},
  ): AppThunk =>
  async (dispatch) => {
    dispatch(
      delineationActions.select({
        delineationId,
        meta: { history },
      }),
    );
  };
